import React from 'react';
import {
  EFilterFieldTypes,
  IAppliedFilter,
  IFilterableField,
} from 'v2/common/ComposeFilters/filters';
import { EntityOwnerFilter } from '../FilterFields/EntityOwnerFilter';
import classnames from 'classnames';
import styles from './fieldValueSelector.module.scss';
import backButtonStyles from '../BackButton.module.scss';
import backIcon from 'v2/icons/angle.svg';
import { useForm, FormProvider } from 'react-hook-form';

interface IFieldValueSelectorProps {
  field: IFilterableField;
  onClickBack: () => void;
  onAppliedFilter: (filter: IAppliedFilter) => void;
}

type FieldValueSelectorFormFields = Pick<IAppliedFilter, 'operation' | 'value'>;

type FieldValueProps = Pick<IFieldValueSelectorProps, 'field'>;

const FieldValue = ({ field }: FieldValueProps) => {
  switch (field.type) {
    case EFilterFieldTypes.owner:
      return <EntityOwnerFilter />;

    default:
      return <div>Not implemented yet!</div>;
  }
};

export const FieldValueSelector = ({
  field,
  onClickBack,
  onAppliedFilter,
}: IFieldValueSelectorProps) => {
  const methods = useForm<FieldValueSelectorFormFields>();

  const handleApplyFilter = methods.handleSubmit((data) => {
    onAppliedFilter({
      field: field,
      operation: data.operation,
      value: data.value,
    });
  });

  return (
    <FormProvider {...methods}>
      <div
        className={classnames(styles.modalBody)}
        data-testid="FieldValueSelector"
      >
        <div className={classnames(styles.modalContent)}>
          <button
            className={classnames(styles.back, backButtonStyles.back)}
            onClick={onClickBack}
          >
            <img src={backIcon} alt="back" />
            Back
          </button>
          <h5 className={classnames(styles.filterTitle)}>
            {field.displayName}
          </h5>
          <FieldValue field={field} />
        </div>
        <div className={classnames(styles.modalFooter)}>
          <button
            className="btn btn-primary"
            disabled={!methods.formState.isValid}
            onClick={handleApplyFilter}
          >
            Apply Filter
          </button>
        </div>
      </div>
    </FormProvider>
  );
};
